module.exports = __webpack_public_path__ + "img/bespoke_cubeAir106.e806feac.png";